/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Alert, AlertProps } from '@mantine/core'
import { useFormContext } from '@jalik/react-form'

function FormErrorAlert (props: AlertProps) {
  const form = useFormContext()
  return (
    form.submitError
      ? <Alert color="red" {...props}>
        {form.submitError.message}
      </Alert>
      : null
  )
}

export default FormErrorAlert
